import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";

const initialValue = {
    riders: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_RIDER_DATA': {
            return {
                ...state,
                rider_list: action.payload,
            }
        }
        case 'UPDATE_RIDER_DATA': {
            let newData = state.rider_list.riders.map((admin) =>
                action.payload.id === admin.id ? action.payload : admin
            );

            let newState = {
                riders: newData
            }

            return {
                ...state,
                rider_list: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const RiderContext = createContext({
    rider_list: initialValue,
    getRiders: () => { },
    getRider: () => { },
    addRider: () => { },
    updateRider: () => { },
    changeStatus: () => { },
})

export const RiderProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {})

    const { setError } = useError();


    const getRiders = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/riders/get_riders', options);

            dispatch({
                type: 'LOAD_RIDER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const getRider = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/riders/get_rider/' + id, options);

            return res.data;
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    const addRider = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            return await axios.post('/api/riders/add_admin', data, options);
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return e;
        }
    }

    const updateRider = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            return await axios.post('/api/riders/update_admin', data, options);
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return e;
        }
    }

    const changeStatus = async (id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.get(`/api/riders/change_status/${id}/${status}`, options);
            dispatch({
                type: 'UPDATE_RIDER_DATA',
                payload: res.data,
            })
            return res.data;
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    useEffect(() => {
        getRiders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    if (state.status === 401) {
        return <SessionOut />
    }


    if (state.rider_list === undefined) {
        return <MatxLoading />
    }

    return (
        <RiderContext.Provider
            value={{
                rider_list: state.rider_list,
                getRiders,
                getRider,
                addRider,
                updateRider,
                changeStatus,
            }}
        >
            {children}
        </RiderContext.Provider>
    )
}

export default RiderContext
